var modules_3f9ccc85 = {"appBanner":"_lh7kop","storesBanner":"_u4q0jq","contactsBanner":"_4ehxxk"};
import "../../../assets/xb8D0zSB.css";

export { modules_3f9ccc85 as default };
//# sourceMappingURL=MainContent.module.less.js.map
